/**
 * Wrapper de compatibilidade Grid v4/v5 -> v6+.
 *
 * Em MUI v6 a API mudou: `<Grid item xs={6}>` virou `<Grid size={{ xs: 6 }}>`,
 * e a prop `item` foi removida. Em MUI v7+ o componente legacy `GridLegacy` foi
 * eliminado. Para preservar 100% do comportamento original do código pré-v6
 * sem reescrever cada call site, este wrapper aceita as props antigas (`item`,
 * `xs/sm/md/lg/xl`) e traduz para a nova API (`size`).
 *
 * Uso:
 *   import Grid from '<path>/components/material/GridLegacyCompat';
 *   <Grid container ...>
 *     <Grid item xs={12} md={6}>...</Grid>
 *   </Grid>
 *
 * Sobre `md={0}` etc.: em v4 valores 0 não eram suportados oficialmente
 * (range 1-12 ou false/auto), mas o código legado passa 0 em alguns lugares
 * (provavelmente para "esconder" no breakpoint). Aqui tratamos 0 como
 * "não aplicar size neste breakpoint" — comportamento idêntico ao v4
 * que ignorava valores não-numéricos válidos.
 */
import React from 'react';
import MuiGrid from '@mui/material/Grid';

const BREAKPOINTS = ['xs', 'sm', 'md', 'lg', 'xl'];

export default function Grid({ item, ...rest }) {
  if (!item) {
    return <MuiGrid {...rest} />;
  }

  const size = {};
  const passthrough = {};
  Object.keys(rest).forEach((key) => {
    if (BREAKPOINTS.includes(key)) {
      const value = rest[key];
      if (value !== undefined && value !== null && value !== 0 && value !== false) {
        size[key] = value;
      }
    } else {
      passthrough[key] = rest[key];
    }
  });

  return <MuiGrid size={Object.keys(size).length > 0 ? size : undefined} {...passthrough} />;
}
